module.exports = __webpack_public_path__ + "static/media/cp7.5a00adac.png";